module.exports = __webpack_public_path__ + "img/positions2.89051b11.png";